<template>
  <div>
    <div
      class="page-header clear-filter d-flex justify-content-center align-items-center"
      filter-color="dark"
    >
      <parallax class="page-header-image" style="background-color:#26a23e"></parallax>
      <div class="content-center">
        <div class="container">
          <div class="content-center brand">
            <h1 class="h1-seo">Nuestros Proyectos</h1>
          </div>
        </div>
      </div>
      <vue-particles color="#bbbbbb" :particleOpacity="0.5" :lineOpacity="0.3" :clickEffect="false"></vue-particles>
    </div>

    <div class="section section-product">
      <div class="features">
        <div class="container">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto text-center">
              <h2 class="title">DOCTOR +</h2>
              <h4
                class="description"
              >Plataforma para video citas en línea, llamadas y video llamadas.</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5 d-flex align-items-center justify-content-center">
              <div class="tablet-container">
                <img src="img/projects/doctor-mobile.png" lazy="loaded" />
              </div>
            </div>
            <div class="col-md-7">
              <div class="info info-horizontal">
                <div class="icon text-primary mt-0">
                  <i class="fas fa-address-book"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Registro facil</h4>
                  <p>Cualquier usuario puede registrarse fácilmente, además se integra con Google y Facebook.</p>
                </div>
              </div>
              <div class="info info-horizontal pt-0">
                <div class="icon text-primary mt-0 mr-1">
                  <i class="fas fa-video"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Videollamadas</h4>
                  <p>La consulta se realiza a través de la aplicación con un sistema de videollamadas integrado.</p>
                </div>
              </div>
              <div class="info info-horizontal pt-0">
                <div class="icon text-primary mt-0">
                  <i class="fas fa-calendar-alt"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Integración con calendario</h4>
                  <p>Registra la cita en la app de calendario de tu telefono android o iPhone teniendo un mayor control de tu videoconsulta.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section section-product">
      <div class="features">
        <div class="container">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto text-center">
              <h2 class="title">Quote</h2>
              <h4
                class="description"
              >Plataforma y sistema para cotizaciones en línea, manejo de negocios, postulaciones y horas laborales y control de cambios en el proyecto.</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="info info-horizontal">
                <div class="icon text-info mt-0">
                  <i class="fas fa-headset"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Videoconferencias</h4>
                  <p>Programe reuniones con sus clientes desde Quote, esto le permitirá agilizar procesos y optimizar tiempos de ejecución.</p>
                </div>
              </div>
              <div class="info info-horizontal">
                <div class="icon text-info mt-0">
                  <i class="fas fa-palette"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Personalizable</h4>
                  <p>Personalice el look para adaptarlo a su compañía. Cualquier combinación de colores es posible.</p>
                </div>
              </div>
            </div>
            <div class="col-md-4 d-flex align-items-center justify-content-center">
              <div class="phone-container">
                <img src="img/projects/quote-desktop2.png" lazy="loaded" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="info info-horizontal">
                <div class="icon text-info mt-0">
                  <i class="fas fa-hand-holding-usd"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Estimaciones</h4>
                  <p>Planifique sus proyectos mediante presupuestos y proyecciones, determine utilidades desde el dashboard administrativo.</p>
                </div>
              </div>
              <div class="info info-horizontal">
                <div class="icon text-info mt-0">
                  <i class="fas fa-columns"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Todo en un solo lugar</h4>
                  <p>Visualice todo lo que necesita en un dashboard simple, pero poderoso. Registre órdenes de cambio y tenga control en la plataforma.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section section-product">
      <div class="features">
        <div class="container">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto text-center">
              <h2 class="title">LearnAll</h2>
              <h4
                class="description"
              >Plataforma para clases y capacitaciones en línea, video llamadas en tiempo real, asistencia de personas, videos en 360 y VR.</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-7">
              <div class="info info-horizontal">
                <div class="icon text-warning mt-0">
                  <i class="fas fa-columns"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Dashboard Simple</h4>
                  <p>Profesores, alumnos, clases... Encuentre todo lo que necesita en un solo lugar.</p>
                </div>
              </div>
              <div class="info info-horizontal pt-0">
                <div class="icon text-warning mt-0 mr-1">
                  <i class="fas fa-video"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Video y Streaming</h4>
                  <p>El profesor puede grabar o hacer streaming de clases. Los estudiantes serán capaces de reproducirlos cuando quieran.</p>
                </div>
              </div>
              <div class="info info-horizontal pt-0">
                <div class="icon text-warning mt-0">
                  <i class="fas fa-mobile-alt"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Aplicación móvil</h4>
                  <p>
                    Estudiantes y profesores podrán inscribirse a clases, publicar videos, reproducir contenidos de clase y ver
                    streaming desde cualquier dispositivo móvil
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-5 d-flex align-items-center justify-content-center">
              <div class="tablet-container">
                <img src="img/projects/learn-mobile3.png" lazy="loaded" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section section-product">
      <div class="features">
        <div class="container">
          <div class="row">
            <div class="col-md-8 ml-auto mr-auto text-center">
              <h2 class="title">Spark Metrics</h2>
              <h4
                class="description"
              >Sistema de monitoreo y automatización hecho a medida y bajo estándares de eficiencia energetica, capaz de recolectar datos de diferentes sensores.</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="info info-horizontal">
                <div class="icon text-primary mt-0">
                  <i class="fas fa-cogs"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Automatización</h4>
                  <p>Controle sus dispositivos desde la plataforma. Capacidad de encender y apagar su aire acondicionado, licuadora, luces, etc.</p>
                </div>
              </div>
              <div class="info info-horizontal">
                <div class="icon text-primary mt-0">
                  <i class="fas fa-chart-pie"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Gráficas</h4>
                  <p>Podrá encontrar gráficas de consumo, voltaje vs. amperaje y tendrá la capacidad de elegir el intervalo de tiempo que desea ver.</p>
                </div>
              </div>
            </div>
            <div class="col-md-4 d-flex align-items-center justify-content-center">
              <div class="phone-container">
                <img src="img/projects/spark-desktop.png" lazy="loaded" />
              </div>
            </div>
            <div class="col-md-4">
              <div class="info info-horizontal">
                <div class="icon text-primary mt-0">
                  <i class="fas fa-shield-alt"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Integridad de los datos</h4>
                  <p>La data es almacenada localmente y replicada en la nube, esto garantiza la recolección de datos con o sin internet.</p>
                </div>
              </div>
              <div class="info info-horizontal">
                <div class="icon text-primary mt-0">
                  <i class="fas fa-chart-line"></i>
                </div>
                <div class="description text-left">
                  <h4 class="info-title mt-0">Monitoreo en tiempo real</h4>
                  <p>Proporciona visibilidad en tiempo real sobre el consumo y producción de energía (eólica o solar).</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section section-products">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center mb-4">
            <h2 class="title m-0 p-0">Otros proyectos</h2>
          </div>
          <div class="col-12">
            <div id="slider">
              <transition-group tag="div" :name="transitionName" class="slides-group">
                <div v-if="show" :key="current" class="slide">
                  <div class="row w-100">
                    <div class="col-md-8 mx-auto">
                      <div class="card">
                        <div class="card-body">
                          <h3 class="title mt-0 pt-3">{{slides[current].title}}</h3>
                          <p class="description">{{slides[current].description}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition-group>
              <div class="btn btn-prev" aria-label="Previous slide" @click="slide(-1)">&#10094;</div>
              <div class="btn btn-next" aria-label="Next slide" @click="slide(1)">&#10095;</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="section-story-overview pt-0">
        <div class="row m-0">
          <div class="col-md-8 mx-auto">
            <h3 class="text-center">
              Algunos de nuestros clientes:</h3>
              <p class="description text-center">
                <em>
                  Laboratorios ARSAL, Laboratorios PAILL, SEED Comunity,
                Corporacion Polaris, Order in Seconds, PNUD, VOGUE CORP, DC SOCIAL Boston, Colegio de
                contadores de Costa Rica, QuickPick LLC, Brothers Mechanicals INC, Hospital de la Mujer, Cerme
                S.A. de C.V., Cefinco S.A. de C.V., Cardedeu, Panadería BanBan, Electrotécnica S.A. de C.V.,
                Unitape S.A. de C.V., Probe S.A. de C.V., Centimetro Cuadrado S.A. de C.V., Dircam S.A. de C.V.
                Disprobe S.A. de C.V., MotoAction S.A. de C.V. La Hipotecaria, Hidrosagarra S.A. de C.V.,
                HASGAR S.A. de C.V.
                </em>
              </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "projects",
  bodyClass: "projects-page",
  data() {
    return {
      social: {
        title: "Nuestros Proyectos - Eficiencia Energética y Seguridad",
        description:
          "Somos una empresa que nace en 2015, ofrecemos consultoría, diseño, construcción, integración, mantenimiento integral y asistencia técnica en informática y tecnología.",
        image: "https://proyectosees.com/img/ees-icon.jpg"
      },
      slides: [
        {
          title: "PROYECTO RESIDENCIA ZZ",
          description: `Automatización de residencia completa, iluminación, cortinas, audio, video, aires
acondicionados, intercomunicador y control de Accesos. Control de voz (ALEXA). CCTV.
CINEMA en Deck. Cableado estructurado red LAN, WIFI y video.`
        },
        {
          title: "SEED SANTA ELENA Y ESCALÓN",
          description: `Instalación de red, Red LAN, WiFi, alarma, suministro y automatización de Aires
acondicionado y control de acceso. Suministro e integración de telefonía IP.`
        },
        {
          title: "FUSADES",
          description: `Control y automatización de planta eléctrica, desconexión automática de sistema
fotovoltaico. Medición de producción y consumo energético`
        },
        {
          title: "HOSPITAL DE LA MUJER",
          description: `Reestructuración y optimización de Red LAN y WIFI, integración con FireWall y
optimización y virtualización de servidores.`
        },
        {
          title: "CERME",
          description: `Optimización de Red, integración con FireWall y optimización de servidores. `
        },
        {
          title: "PROYECTO RESIDENCIA EM",
          description: `Automatización de residencia completa, iluminación, cortinas, audio, video, aires
acondicionados, intercomunicador y control de Accesos. Control de voz (ALEXA).
Sistema Fotovoltaico, medición de consumo y producción de energía. Sistema de
calefacción Solar para piscina. CCTV. CINEMA en sotano. Cableado estructurado red
LAN, WIFI y video. Sistema de riego automatico.`
        },
        {
          title: "PROYECTO RESIDENCIA TC",
          description: `Automatización de residencia completa, iluminación, audio, video, Sistema de
calefacción de GAS para piscina. CCTV. Cinema en Deck. Cableado estructurado red
LAN, WIFI y video.`
        },
        {
          title: "PROYECTO RESIDENCIA ST",
          description: `Automatización de residencia completa, iluminación, audio, video, CCTV. Cinema en
Deck. Cableado estructurado red LAN, WIFI y video.`
        },
        {
          title: "POLARIS SANTA ELENA",
          description: `Renovación de sistema CCTV con cámaras IP. `
        },
        {
          title: "PROYECTO RESIDENCIA SS",
          description: `Automatización de residencia completa, iluminación, audio, video, CCTV. Cinema en N2.
Cableado estructurado red LAN, WIFI y video.`
        },
        {
          title: "CENTURY TOWER ZR",
          description: `Cableado estructurado con comunicación a 10Gbps para todo el edificio F/O MM, Red
LAN, WiFi, Automatización de luces áreas comunes, audio, sistema de control de acceso
vehicular, sistema de control de acceso de personas, alarma de detección de incendios,
telefonía IP, desarrollo de APP Móvil y sistema de CCTV.`
        },
        {
          title: "PROYECTO IMPRENTA BELLAS ARTES",
          description: `Reestructuración de red, Red LAN, WiFi y optimización de equipos.`
        },
        {
          title: "QUEDEX S.A. de C.V.",
          description: `Optimización de la red LAN, optimización y virtualización de servidores.`
        },
        {
          title: "SEED ZONA ROSA",
          description: `Instalación de red LAN, WiFi, sistema de control de acceso.`
        },
        {
          title: "PROYECTO SUPERINTENDENCIA",
          description: `nstalación de sistema de control de incendios.`
        },
        {
          title: "PROYECTO RESIDENCIA HS",
          description: `Automatización de residencia completa, iluminación, cortinas, audio, video, aires
acondicionados, intercomunicador y control de Accesos. Control de voz (ALEXA).
Sistema de calefacción Solar para piscina. CCTV. CINEMA en Terraza. Cableado
estructurado red LAN, WIFI y video.
`
        },
        {
          title: "APLICACION WEB y MOVIL ¨CENTURY HUB¨",
          description: `Plataforma y APP para el alquiler de oficinas, reserva de espacios y alquiler de servicios.
TypeScript, ionic, NodeJS, MySQL, Amazon AWS.`
        }
      ],
      current: 0,
      direction: 1,
      transitionName: "fade",
      show: false
    };
  },
  mounted() {
    this.show = true;
  },
  head: {
    title: {
      inner: "Nuestros Proyectos"
    },
    // Meta tags
    meta() {
      return [
        { n: "application-name", c: "Eficiencia Energética y Seguridad" },
        { n: "description", c: this.social.description, id: "desc" }, // id to replace intead of create element
        // ...
        // Twitter
        { n: "twitter:card", c: "summary" },
        // { n: 'twitter:site', c: '@username' },
        { n: "twitter:title", c: this.social.title },
        { n: "twitter:description", c: this.social.description },
        // { n: 'twitter:creator', c: '@username' },
        { n: "twitter:image", c: this.social.image },
        // Google+ / Schema.org
        { itemprop: "name", c: this.social.title },
        { itemprop: "description", c: this.social.description },
        { itemprop: "image", c: this.social.image },
        // Facebook / Open Graph
        { p: "og:title", c: this.social.title },
        { p: "og:type", c: "website" },
        { p: "og:url", c: "https://proyectosees.com/projects" },
        { p: "og:image", c: this.social.image },
        { p: "og:description", c: this.social.description },
        { p: "og:site_name", c: "Eficiencia Energética y Seguridad" }
        // { p: 'fb:app_id', c: '123456789' },
      ];
    }
  },
  methods: {
    slide(dir) {
      this.direction = dir;
      dir === 1
        ? (this.transitionName = "slide-next")
        : (this.transitionName = "slide-prev");
      var len = this.slides.length;
      this.current = (this.current + (dir % len) + len) % len;
    }
  }
};
</script>
<style>
.section-product .info .icon > i {
  font-size: 2.5em;
}
.section-product .features img {
  max-height: 500px;
}

@media screen and (max-width: 767.87px) {
  .section-product .features img {
    max-height: 400px;
  }

  #slider {
    width: 100%;
    min-height: 469px;
    position: relative;
  }
}

/* GO TO NEXT SLIDE */
.slide-next-enter-active,
.slide-next-leave-active {
  transition: transform 0.5s ease-in-out;
}
.slide-next-enter {
  transform: translate(100%);
}
.slide-next-leave-to {
  transform: translate(-100%);
}

/* GO TO PREVIOUS SLIDE */
.slide-prev-enter-active,
.slide-prev-leave-active {
  transition: transform 0.5s ease-in-out;
}
.slide-prev-enter {
  transform: translate(-100%);
}
.slide-prev-leave-to {
  transform: translate(100%);
}


#slider {
  width: 100%;
  min-height: 400px;
  position: relative;
}

.slide {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

#slider .btn {
  z-index: 10;
  border: solid #333 1px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: 35px;
  height: 35px;
  position: absolute;
  top: calc(50% - 35px);
  left: 1%;
  transition: transform 0.3s ease-in-out;
  user-select: none;
  background: transparent !important;
  color: #333 !important;
}

#slider .btn-next {
  left: auto;
  right: 1%;
}

#slider .btn:hover {
  transform: scale(1.1);
}
</style>
